<template>
    <b-card>
        <div class="table-header-container d-flex justify-content-between align-items-center pt-2 pb-3">
            <div class="title-container d-flex align-items-center">
                <h2 class="pr-1 mb-0">{{title}}</h2>
                <span>{{rows.length}} დაწესებულება</span>
            </div>

            <div>
                <b-button variant="flat-secondary" class="btn-icon btn-lg" size="lg"
                          @click="$emit('edit', {id: $vnode.key, isRegion: true})">
                    <feather-icon icon="Edit3Icon" size="18"/>
                </b-button>

                <b-button variant="flat-secondary" class="btn-icon btn-lg mr-1" size="lg"
                          @click="$emit('delete', {id: $vnode.key, isRegion: true})">
                    <feather-icon icon="Trash2Icon" size="18"/>
                </b-button>

                <b-button variant="secondary" class="btn-icon" @click="$emit('add', $vnode.key)">
                    <feather-icon icon="PlusIcon"
                                  class="mr-50"/>
                    <span class="align-middle">ახალი დაწესებულება</span>
                </b-button>

                <b-button variant="secondary" class="toggle-button btn-icon ml-1" @click="toggleTable">
                    <feather-icon :class="{'rotate': !tableVisible}" icon="ChevronUpIcon"/>
                </b-button>
            </div>
        </div>
        <b-table responsive="sm"
                 :fields="columns"
                 v-if="tableVisible"
                 outlined
                 small
                 hover
                 show-empty
                 empty-text="დაწესებულება არ არის დამატებული"
                 class="institutions-table"
                 :class="{'hide': !tableVisible}"
                 :items="rows">

            <template #cell(actions)="{item}" td-class="text-right">
                <b-button variant="flat-secondary" :key="item.id" class="btn-icon"
                          @click="$emit('edit',  {id: item.id, isRegion: false})">
                    <feather-icon icon="Edit3Icon"/>
                </b-button>

                <b-button variant="flat-danger" class="btn-icon"
                          @click="$emit('delete', {id: item.id, isRegion: false})">
                    <feather-icon icon="Trash2Icon"/>
                </b-button>
            </template>
        </b-table>


    </b-card>
</template>

<script>
    import {BCard, BTable, BButton} from "bootstrap-vue"

    export default {
        components: {
            BCard,
            BTable,
            BButton
        },
        props: ["rows", "title", "columns"],

        data() {
            return {
                perPage: 5,
                currentPage: 1,
                boxTwo: "",
                tableVisible: true,
            }
        },

        computed: {
            patientsCount() {
                return this.rows.length
            }
        },

        mounted() {
        },

        methods: {
            warning() {
                this.$swal({
                    title: "<span class=\"font-medium-1\">დარწმუნებული ხარ რომ გსურს წაშლა?</span>",
                    icon: "warning",
                    html:
                        "<span class=\"font-small-3\">წაშლის შემდეგ ინფორმაციის აღდგენა შეუძლებელია</span>",
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: "დიახ წაშალე",
                    cancelButtonText: "გაუქმება",
                    customClass: {
                        confirmButton: "btn btn-primary",
                        cancelButton: "btn btn-outline-danger ml-1",
                    },
                    buttonsStyling: false,
                })
            },

            editInstitution(id) {
                console.log("edit id", id)
            },

            deleteInstitution(id) {
                console.log("delete id", id)
            },

            toggleTable() {
                this.tableVisible = !this.tableVisible;
            }
        }
    }
</script>

<style lang="scss">

    .table-responsive-sm .table td[aria-colindex='7'] {
        text-align: right;
    }

    .card .table tbody tr:last-child td:first-child {
      font-weight: normal !important;
    }

    .table-responsive-sm .table th[aria-colindex='7'] div {
        display: none;
    }

    .toggle-button {
        svg {
            transition: 0.2s all ease;
        }

        .rotate {
            -webkit-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
        }
    }

    .card .table tbody tr:last-child td:first-child {
        font-weight: bold;
    }

</style>
